import { AfterViewInit, Component, ElementRef, OnDestroy, inject } from '@angular/core';

import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams, IRowNode } from 'ag-grid-community';

import { CheckboxComponent } from '@camelot/form-input';
import { InputCheckBox } from '@camelot/form-model';

@Component({
  selector: 'cam-grid-selection-header',
  templateUrl: './selection-header.component.html',
  styleUrl: './selection-header.component.scss',
  imports: [CheckboxComponent],
})
export class SelectionHeaderComponent implements IHeaderAngularComp, AfterViewInit, OnDestroy {
  public input = new InputCheckBox({ key: 'grid-selection-all' });

  private _params: IHeaderParams | null = null;
  private readonly _elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly _sync = () => {
    if (!this._params) {
      return;
    }
    const selectedCount = this._params.api.getSelectedNodes().length;
    const rowCount = this._getRowNodes().length;
    const allSelected = rowCount > 0 && selectedCount >= rowCount;
    this.input.value = allSelected;
    this._setIndeterminate(selectedCount > 0 && !allSelected);
  };

  ngAfterViewInit(): void {
    this._sync();
  }

  ngOnDestroy(): void {
    this._params?.api.removeEventListener('selectionChanged', this._sync);
    this._params?.api.removeEventListener('modelUpdated', this._sync);
  }

  agInit(params: IHeaderParams): void {
    this._params = params;
    params.api.addEventListener('selectionChanged', this._sync);
    params.api.addEventListener('modelUpdated', this._sync);
  }

  refresh(params: IHeaderParams): boolean {
    this._params = params;
    return true;
  }

  public toggleAll(selected: boolean): void {
    this._params?.api.setNodesSelected({ newValue: selected, nodes: this._getRowNodes() });
  }

  private _getRowNodes(): IRowNode[] {
    const nodes: IRowNode[] = [];
    this._params?.api.forEachNode(node => {
      if (node.data) {
        nodes.push(node);
      }
    });
    return nodes;
  }

  private _setIndeterminate(indeterminate: boolean): void {
    const element = this._elementRef.nativeElement.querySelector<HTMLInputElement>('input[type="checkbox"]');
    if (element) {
      element.indeterminate = indeterminate;
    }
  }
}
